import { initElements } from '../define/shared';

export default function initHeader() {
    initElements('.siteHeader', header => {
        const menuBtn = header.querySelector('.siteHeader-menuBtn');
        const menu    = header.querySelector('.siteHeader-menu');
        const closeBtn = document.createElement('span');

        closeBtn.classList.add('icon', 'icon-close');
        menu.appendChild(closeBtn);

        menuBtn.addEventListener('click', () => {
            menu.classList.add('is--open');
        });

        closeBtn.addEventListener('click', () => {
            menu.classList.remove('is--open');
        });

        document.addEventListener('click', (event) => {
            if (event.target.contains(menu)) {
                menu.classList.remove('is--open');
            }
        });
    });
}
